import {
  APPOINTMENT_MAKE_NEW_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_LOCATION_DOCTOR_CONSULT_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_LOCATION_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_SERVICE_TYPE_PATH,
  HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_OTP_PATH,
  HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_PATH,
  HEALTHIERSG_HEALTHPLAN_GET_VACCINATED_PATH,
  HEALTHIERSG_HEALTHPLAN_PATH,
  HEALTHIERSG_RECOMMENDATION_SIGNPOSTING_PATH,
  HEALTHIERSG_RECORDS_HEALTH_SCREENING_PATH,
  HEALTHIERSG_RECORDS_SCREENING_PATH,
  HEALTHIERSG_RESULTSANDRECORDS_PATH,
  HEALTHIERSG_SCREENING_JOURNEY_APPOINTMENT_MADE_PATH,
  LAB_TEST_REPORTS_PATH,
  MEDREFILL_HISTORY_PATH,
  MEDREFILL_PATH,
  MEDREFILL_REFILL_REFILL_OPTIONS_PATH,
  MEDREFILL_TOPUP_REPEAT_PRESCRIPTION_LIST_PATH,
  ROUTER_BACK_PATH,
} from '@shared/constants/paths';

const VALID_ORIGIN: string[] = [
  APPOINTMENT_MAKE_NEW_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_LOCATION_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_LOCATION_DOCTOR_CONSULT_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_SERVICE_TYPE_PATH,
  MEDREFILL_PATH,
  MEDREFILL_REFILL_REFILL_OPTIONS_PATH,
  MEDREFILL_TOPUP_REPEAT_PRESCRIPTION_LIST_PATH,
  MEDREFILL_HISTORY_PATH,
  HEALTHIERSG_HEALTHPLAN_GET_VACCINATED_PATH,
  HEALTHIERSG_HEALTHPLAN_PATH,
  HEALTHIERSG_RECOMMENDATION_SIGNPOSTING_PATH,
  ROUTER_BACK_PATH,
  LAB_TEST_REPORTS_PATH,
  HEALTHIERSG_SCREENING_JOURNEY_APPOINTMENT_MADE_PATH,
  HEALTHIERSG_RECORDS_SCREENING_PATH,
  HEALTHIERSG_RESULTSANDRECORDS_PATH,
  HEALTHIERSG_RECORDS_HEALTH_SCREENING_PATH,
  HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_PATH,
  HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_OTP_PATH,
];

export { VALID_ORIGIN };
